import React, {useEffect, useState} from "react";
import {Box, Paper, Stack, Pagination} from "@mui/material";
import {useNavigate, useLocation} from "react-router-dom";
import CustomButton from "../../../core/components/ui/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import AddIcon from "@mui/icons-material/Add";
import ListGatePassConfigurationComponent from "../components/gatepass-configuration/list-gatepass-configuration.component";
import useGatePassConfiguration from "../hooks/useGatePassConfiguration";
import CustomTableLoaderComponent from "../../../core/components/common/custom-table-loader.component";
import AddGatePassConfigurationDialog from "../components/gatepass-configuration/add-gatepass-configuration.dialog";
import useGatePassConfigurationStore from "../zustand/useGatePassConfigurationStore";


const headers = ["Entry Type", "Gate Pass Type", "Status", "Actions"];

const GatePassConfigurationPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const {isFetchingGatePassConfigurationList, gatePassConfigurationListData, listProfileGatePassConfiguration} = useGatePassConfiguration();
    const {isGatePassConfigurationStatusUpdated, isGatePassConfigurationDeleted} = useGatePassConfigurationStore();

    const [gatePassConfigurationList, setGatePassConfigurationList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [openAddGatePassConfiguration, setOpenAddGatePassConfiguration] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);

    const rowsPerPage = 10;
    const profileGatePassConfigurationRole = new URLSearchParams(location.search).get("role");


    useEffect(() => {
        const parameters = {
            page: 1,
            limit: rowsPerPage,
            role: profileGatePassConfigurationRole
        };
    
        listProfileGatePassConfiguration(parameters);    
    }, []);

    useEffect(() => {
        if (gatePassConfigurationListData) {
            setGatePassConfigurationList(gatePassConfigurationListData?.content);
            setTotalPages(gatePassConfigurationListData?.totalPages);
        }  
    }, [gatePassConfigurationListData])

    useEffect(() => {
        if (currentPage || isGatePassConfigurationStatusUpdated || isGatePassConfigurationDeleted) {
            const parameters = {
                page: currentPage,
                limit: rowsPerPage,
                role: profileGatePassConfigurationRole
            };
        
            listProfileGatePassConfiguration(parameters); 
        }   
    }, [currentPage, isGatePassConfigurationStatusUpdated, isGatePassConfigurationDeleted]);


    const handleChangePagination = (event, page) => { 
        setCurrentPage(page); 
    }

    const handleBack = () => {
        navigate("/rbac");
    }

    const handleOpenAddGatePassConfiguration = () => {
        setOpenAddGatePassConfiguration(true);
        setSelectedRole(profileGatePassConfigurationRole);
    }


    return (
        <>  
            <CustomButton 
                variant="text" 
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to RBAC"
                customStyles={{fontSize: 14, ml: -2}}
                onClick={handleBack}
            />

            <Box sx={{textAlign: "start", mt: 2}}>
                <CustomTypography 
                    variant="h3"
                    text={"Gate Pass Configuration"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"Configure profile gate pass type"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                <Stack direction={{xs: "column", md: "column"}} spacing={2} sx={{mb: 3}}>
                    <Stack direction="row" alignItems="space-between" justifyContent="space-between" spacing={2} flex={1}>
                        <Box sx={{textAlign: "start"}}>
                           <CustomTypography 
                                variant="h3"
                                text={profileGatePassConfigurationRole}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 24,
                                    fontWeight: 600,
                                }}
                            />
                        </Box>

                        <Box sx={{textAlign: "end"}}>
                            <CustomButton 
                                variant={"contained"}
                                label={"Add Gate Pass Configuration"}
                                startIcon={<AddIcon fontSize="small" />}
                                onClick={handleOpenAddGatePassConfiguration}                            
                            /> 
                        </Box>
                    </Stack>
            
                    <Box sx={{mt: "8px !important"}}>
                        {(isFetchingGatePassConfigurationList) ?
                            <Box sx={{mt: 3}}>
                                <CustomTableLoaderComponent 
                                    headers={headers} 
                                    hasAction={false}
                                /> 
                            </Box>
                        :   
                            <Box sx={{mt: 3}}>
                                <ListGatePassConfigurationComponent 
                                    headers={headers} 
                                    data={gatePassConfigurationList} 
                                />

                                {gatePassConfigurationList?.length > 0 &&
                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handleChangePagination}
                                        sx={{
                                            margin: "auto",
                                            width: "fit-content",
                                            paddingTop: 3,

                                            "& .MuiPaginationItem-root.Mui-selected": {
                                                backgroundColor: "#0b99da",      
                                                color: "#fff",               
                                            }
                                        }}
                                    />
                                }   
                            </Box>
                        }
                    </Box>
                </Stack>
            </Paper>

            <AddGatePassConfigurationDialog 
                open={openAddGatePassConfiguration}
                setOpen={setOpenAddGatePassConfiguration}
                selectedRole={selectedRole}
            />
        </>
    )
}

export default GatePassConfigurationPage